export enum EmployerStatus {
  AutomaticallyUpdated = 'Automatically Updated',
  AutomaticallyCreated = 'Automatically Created',
  Blacklisted = 'Blacklisted',
  Contacted = 'Contacted',
  ContractSigned = 'Contract Signed',
  ContractTerminated = 'Contract Terminated',
  Cs = 'CS',
  IndeestoneNotPaid = 'Indeestone Not Paid',
  IndeestonePaid = 'Indeestone Paid',
  Insolvent = 'Insolvent',
  LandingPageRegistered = 'Landing Page Registered',
  LocationChecked = 'Location Checked',
  LocationCreated = 'Location Created',
  LocationPaused = 'Location Paused',
  LocationPublished = 'Location Published',
  NoPartner = 'No Partner',
  NotInterested = 'Not Interested',
  // Not Personally Spoken = Nicht persönlich gesprochen
  NotPersonallySpoken = 'Not Personally Spoken',
  // Not Reached = Nicht Erreicht
  NotReached = 'Not Reached',
  // No Vacancy = Keine Vakanz
  NoVacancy = 'No Vacancy',
  // Number not existent/closed = Nummer nicht Vergeben/geschlossen
  NumberNotExistentOrClosed = 'Number not existent/closed',
  Offline = 'Offline Match',
  OnboardingDone = 'Onboarding Done',
  OnboardingScheduled = 'Onboarding Scheduled',
  // Paused Collaboration = Pausiert - Zusammenarbeit
  PausedCollaboration = 'Paused Collaboration',
  // Paused Pricing = Pausiert - Pricing
  PausedPricing = 'Paused Pricing',
  // Personally Spoken = Persönlich gesprochen
  PersonallySpoken = 'Personally Spoken',
  WarmLead = 'Warm Lead',
}

export const LOCATION_PUBLISHED_STATUSES = [EmployerStatus.LocationPublished, EmployerStatus.IndeestonePaid];

export const LOCATION_PAUSED_STATUSES = [EmployerStatus.LocationPaused, EmployerStatus.PausedCollaboration, EmployerStatus.PausedPricing];

export const LOCATION_PUBLISHED_OR_PAUSED_STATUSES = [...LOCATION_PUBLISHED_STATUSES, ...LOCATION_PAUSED_STATUSES];

export const EMPLOYER_ALIVE_URL_STATUSES = [
  EmployerStatus.LocationPublished,
  EmployerStatus.LocationPaused,
  EmployerStatus.PausedCollaboration,
  EmployerStatus.PausedPricing,
];
